// import React, { useState, useEffect, useRef,useCallback  } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { Calendar, Plus, List, Loader, ChevronRight, Clock, MapPin, Truck, XCircle, X, Bell, AlertTriangle } from "lucide-react";
// import BookingScheduler from "../components/BookingSchedulerNew";
// import ScheduledBookingList from "../components/ScheduledBookingList";
// import BookingGraph from "../components/BookingGraph";
// import { useVehicles } from "../hooks/useVehicles";
// import { useScheduledBookings } from "../hooks/useScheduledBookings";
// import EmployeeLayout from "../components/EmployeeLayout";
// import AdvancedBookingForm from "../pages/Advancedbookingform";
// import {
//   getForkBookingDetailsAll,
//   getFBookingDetails,
//   getForkBookingDetailsByDate,
// } from "../services/bookingService";

// // ─── Cancellation Notification Popup for Employees ──────────────────────────
// function CancelNotificationPopup({ notifications, onDismiss }) {
//   if (!notifications || notifications.length === 0) return null;

//   return (
//     <div className="fixed top-6 right-6 z-[9999] flex flex-col gap-3 max-w-sm w-full">
//       <style>{`
//         @keyframes slideInRight {
//           from { transform: translateX(110%); opacity: 0; }
//           to   { transform: translateX(0);    opacity: 1; }
//         }
//         .cancel-notif { animation: slideInRight 0.3s ease-out; }
//       `}</style>
//       {notifications.map((n) => (
//         <div
//           key={n.id}
//           className="cancel-notif bg-white border-l-4 border-red-500 rounded-xl shadow-2xl p-4"
//         >
//           <div className="flex items-start justify-between gap-2">
//             <div className="flex items-start gap-3">
//               <div className="p-2 bg-red-100 rounded-lg shrink-0 mt-0.5">
//                 <XCircle size={18} className="text-red-600" />
//               </div>
//               <div>
//                 <p className="text-sm font-bold text-gray-900 mb-1">
//                   ⚠️ Your Booking Was Cancelled
//                 </p>
//                 <p className="text-xs font-semibold text-red-700 mb-1">
//                   Booking #{n.bookingId}
//                 </p>
//                 <p className="text-xs text-gray-600 leading-relaxed">
//                   {n.reason}
//                 </p>
//                 <p className="text-xs text-gray-400 mt-2">{n.time}</p>
//               </div>
//             </div>
//             <button
//               onClick={() => onDismiss(n.id)}
//               className="p-1 hover:bg-gray-100 rounded-lg transition shrink-0"
//             >
//               <X size={14} className="text-gray-400" />
//             </button>
//           </div>
//           <button
//             onClick={() => onDismiss(n.id)}
//             className="mt-3 w-full px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-700 text-xs font-semibold rounded-lg transition"
//           >
//             Dismiss
//           </button>
//         </div>
//       ))}
//     </div>
//   );
// }

// // ─── WebSocket Connection for Real-time Updates ────────────────────────────
// const BOOKING_WS_URL = 'wss://aeroviewbackend.dockyardsoftware.com:8095/Booking';

// // Tab Button Component
// function TabButton({ active, onClick, children, icon: Icon }) {
//   return (
//     <button
//       onClick={onClick}
//       className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-all border-b-2 ${
//         active
//           ? "text-gray-900 border-gray-900"
//           : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
//       }`}
//     >
//       {Icon && <Icon size={14} />}
//       {children}
//     </button>
//   );
// }

// // Stat Card Component
// function StatCard({ title, value, icon: Icon, color, onClick }) {
//   const colorClasses = {
//     blue: "bg-blue-50 border-blue-200 text-blue-600",
//     green: "bg-emerald-50 border-emerald-200 text-emerald-600",
//     purple: "bg-purple-50 border-purple-200 text-purple-600",
//     yellow: "bg-yellow-50 border-yellow-200 text-yellow-600",
//     red: "bg-red-50 border-red-200 text-red-600",
//   };
  
//   const bgColor = colorClasses[color] || colorClasses.blue;
  
//   return (
//     <div
//       onClick={onClick}
//       className={`${bgColor} border rounded-lg p-3 cursor-pointer transition-all hover:shadow-md`}
//     >
//       <div className="flex items-center justify-between mb-1">
//         <Icon size={14} className={bgColor.split(' ')[2]} />
//         <span className="text-lg font-bold">{value}</span>
//       </div>
//       <p className="text-xs font-medium">{title}</p>
//     </div>
//   );
// }

// export default function ScheduleBooking() {
//   const navigate = useNavigate();
//   const { authKey, userDetails } = useSelector((state) => state.auth);
//   const {
//     vehicles,
//     loading: vehiclesLoading,
//     error: vehiclesError,
//     loadVehicles,
//   } = useVehicles();
//   const {
//     bookings,
//     loading: bookingsLoading,
//     loadBookings,
//   } = useScheduledBookings();
//   const [showScheduler, setShowScheduler] = useState(false);
//   const [activeTab, setActiveTab] = useState("bookings");
//   const [showAvailability, setShowAvailability] = useState(false);
//   const [availabilityBookings, setAvailabilityBookings] = useState([]);
//   const [availabilityLoading, setAvailabilityLoading] = useState(false);
//   const [showAdvancedForm, setShowAdvancedForm] = useState(false);
  
//   // ─── Cancellation Notifications State ────────────────────────────────────
//   const [cancelNotifications, setCancelNotifications] = useState([]);
  
//   // ─── WebSocket Ref ───────────────────────────────────────────────────────
//   const wsRef = useRef(null);
//   const lastWsFetchRef = useRef(0);
//   const wsFetchTimerRef = useRef(null);

//   useEffect(() => {
//     if (!authKey) {
//       navigate("/login");
//     }
//   }, [authKey, navigate]);

//   const fetchInitialBookingDetails = async () => {
//     console.log("[ScheduleBooking] Fetching initial booking details...");
//     try {
//       const [forkDetails, bookingDetails] = await Promise.all([
//         getForkBookingDetailsAll(),
//         getFBookingDetails(),
//       ]);
//       console.log("[ScheduleBooking] Fork booking details fetched:", forkDetails);
//       console.log("[ScheduleBooking] Booking details fetched:", bookingDetails);
//     } catch (error) {
//       console.error("[ScheduleBooking] Error fetching initial booking details:", error);
//     }
//   };

//   // ─── Refresh All Bookings ────────────────────────────────────────────────
//   const refreshAllBookings = async () => {
//     await Promise.all([
//       loadBookings(),
//       fetchInitialBookingDetails(),
//     ]);
//   };

//   // ─── Show Cancellation Notification (from WebSocket/Admin) ───────────────
//   const showCancelNotification = useCallback((bookingId, reason) => {
//     const n = {
//       id:        `${bookingId}-${Date.now()}`,
//       bookingId,
//       reason,
//       time:      new Date().toLocaleTimeString(),
//     };
//     setCancelNotifications(prev => [...prev, n]);
    
//     // Auto-dismiss after 30 seconds
//     setTimeout(() => {
//       setCancelNotifications(prev => prev.filter(x => x.id !== n.id));
//     }, 30000);
    
//     // Also play a subtle sound if desired (optional)
//     // const audio = new Audio('/notification.mp3');
//     // audio.play().catch(e => console.log('Audio play failed:', e));
//   }, []);

//   const dismissCancelNotification = useCallback((notifId) => {
//     setCancelNotifications(prev => prev.filter(n => n.id !== notifId));
//   }, []);

//   // ─── WebSocket Connection for Real-time Cancellations ────────────────────
//   useEffect(() => {
//     if (!authKey) return;
    
//     // Close existing connection
//     if (wsRef.current) {
//       wsRef.current.close();
//     }
    
//     console.log("[ScheduleBooking] Connecting to WebSocket...");
//     wsRef.current = new WebSocket(`${BOOKING_WS_URL}?token=${encodeURIComponent(authKey)}`);
    
//     wsRef.current.onopen = () => {
//       console.log("[ScheduleBooking] ✅ Booking WebSocket Connected");
//     };
    
//     wsRef.current.onmessage = (event) => {
//       try {
//         const message = JSON.parse(event.data);
//         console.log("[ScheduleBooking] WebSocket message received:", message);
        
//         // Handle cancellation messages from Admin
//         if (message.type === 'BOOKING_CANCELLED' || 
//             message.action === 'cancel' ||
//             message.cancelled === true ||
//             (message.status === 'Cancel' && message.previousStatus === 'Pending')) {
          
//           const bookingId = message.bId || message.bookingId || message.reqId;
//           const cancelReason = message.reason || 
//             message.cancelReason || 
//             "Your booking was cancelled by the administrator as no suitable vehicle was available.";
          
//           if (bookingId) {
//             console.log(`[ScheduleBooking] 📢 Booking ${bookingId} was cancelled by supervisor`);
//             showCancelNotification(bookingId, cancelReason);
            
//             // Refresh bookings to show updated status
//             refreshAllBookings();
//           }
//         }
        
//         // Handle any booking update (including cancellations)
//         if (message.type || message.action || message.bId || message.bookingId) {
//           const now = Date.now();
//           const minGap = 3000; // 3 second throttle
          
//           if (now - lastWsFetchRef.current >= minGap) {
//             lastWsFetchRef.current = now;
//             refreshAllBookings();
//           } else if (!wsFetchTimerRef.current) {
//             const delay = minGap - (now - lastWsFetchRef.current);
//             wsFetchTimerRef.current = setTimeout(() => {
//               lastWsFetchRef.current = Date.now();
//               wsFetchTimerRef.current = null;
//               refreshAllBookings();
//             }, delay);
//           }
//         }
//       } catch (error) {
//         console.error("[ScheduleBooking] Error parsing WebSocket message:", error);
//       }
//     };
    
//     wsRef.current.onerror = (error) => {
//       console.error("[ScheduleBooking] WebSocket Error:", error);
//     };
    
//     wsRef.current.onclose = () => {
//       console.log("[ScheduleBooking] WebSocket Disconnected");
//     };
    
//     return () => {
//       if (wsRef.current) {
//         wsRef.current.close();
//         wsRef.current = null;
//       }
//       if (wsFetchTimerRef.current) {
//         clearTimeout(wsFetchTimerRef.current);
//         wsFetchTimerRef.current = null;
//       }
//     };
//   }, [authKey, showCancelNotification]);

//   useEffect(() => {
//     if (authKey) {
//       loadVehicles();
//       loadBookings();
//       fetchInitialBookingDetails();
//     }
//   }, [authKey, loadVehicles, loadBookings]);

//   // Calculate booking stats - including cancelled count
//   const bookingStats = {
//     total: bookings?.length || 0,
//     pending: bookings?.filter(b => b.status === "Pending" || b.status === "P").length || 0,
//     active: bookings?.filter(b => b.status === "Active" || b.status === "A").length || 0,
//     completed: bookings?.filter(b => b.status === "Completed" || b.status === "CO").length || 0,
//     cancelled: bookings?.filter(b => b.status === "Cancel" || b.status === "C").length || 0,
//   };

//   if (!userDetails) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//         <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-8 text-center max-w-md">
//           <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
//           <h2 className="text-lg font-semibold text-gray-900 mb-1">Loading Your Session</h2>
//           <p className="text-xs text-gray-500">Please wait...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <EmployeeLayout>
//       {/* ─── Cancellation Notification Popups ────────────────────────────── */}
//       <CancelNotificationPopup
//         notifications={cancelNotifications}
//         onDismiss={dismissCancelNotification}
//       />

//       {/* Header Section */}
//       <div className="mb-4">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
//           <div>
//             <h1 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
//               <Calendar size={20} />
//               Booking
//             </h1>
//             <p className="text-xs text-gray-500 mt-0.5">
//               Book vehicles with precision timing
//             </p>
//           </div>
//           <div className="flex flex-wrap gap-2">
//             {!showScheduler && !showAdvancedForm && (
//               <button
//                 onClick={async () => {
//                   const isOpening = !showAvailability;
//                   if (isOpening) {
//                     setAvailabilityLoading(true);
//                     try {
//                       const today = new Date();
//                       const startOfWeek = new Date(today);
//                       startOfWeek.setDate(today.getDate() - today.getDay() + 1);
//                       const weekDates = [];
//                       for (let i = 0; i < 7; i++) {
//                         const date = new Date(startOfWeek);
//                         date.setDate(startOfWeek.getDate() + i);
//                         weekDates.push(date.toISOString().split("T")[0]);
//                       }
//                       const bookingsArrays = await Promise.all(
//                         weekDates.map((date) => getForkBookingDetailsByDate(date))
//                       );
//                       const allBookings = bookingsArrays.flat();
//                       setAvailabilityBookings(Array.isArray(allBookings) ? allBookings : []);
//                     } catch (error) {
//                       console.error("Error fetching fork bookings:", error);
//                       setAvailabilityBookings([]);
//                     } finally {
//                       setAvailabilityLoading(false);
//                     }
//                   }
//                   setShowAvailability(isOpening);
//                   if (isOpening) setShowScheduler(false);
//                 }}
//                 disabled={availabilityLoading}
//                 className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition ${
//                   showAvailability
//                     ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     : "bg-gray-900 text-white hover:bg-gray-800"
//                 } disabled:opacity-50`}
//               >
//                 <Calendar size={14} />
//                 {availabilityLoading ? "Loading..." : showAvailability ? "Hide Availability" : "Check Availability"}
//               </button>
//             )}
            
//             {!showScheduler && !showAdvancedForm && (
//               <button
//                 onClick={() => {
//                   setShowAdvancedForm(true);
//                   setShowAvailability(false);
//                 }}
//                 className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition"
//               >
//                 <Plus size={14} />
//                 Unplanned Booking
//               </button>
//             )}

//             {(!showScheduler || activeTab === "bookings") && !showAdvancedForm && (
//               <button
//                 onClick={() => {
//                   setShowScheduler(true);
//                   setActiveTab("create");
//                   setShowAvailability(false);
//                 }}
//                 className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 transition"
//               >
//                 <Plus size={14} />
//                 New Booking
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Stats Cards - Added Cancelled stat */}
//       <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4">
//         <StatCard title="Total Bookings" value={bookingStats.total} icon={Calendar} color="blue" />
//         <StatCard title="Active" value={bookingStats.active} icon={Clock} color="green" />
//         <StatCard title="Pending" value={bookingStats.pending} icon={Loader} color="yellow" />
//         <StatCard title="Completed" value={bookingStats.completed} icon={Truck} color="purple" />
//         <StatCard title="Cancelled" value={bookingStats.cancelled} icon={XCircle} color="red" />
//       </div>

//       {/* WebSocket Status Indicator */}
//       <div className="flex items-center justify-end mb-3">
//         <div className="flex items-center gap-2 px-2 py-1 bg-gray-50 rounded-full">
//           <div className={`w-2 h-2 rounded-full ${wsRef.current?.readyState === WebSocket.OPEN ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`}></div>
//           <span className="text-xs text-gray-500">
//             {wsRef.current?.readyState === WebSocket.OPEN ? 'Live Updates Active' : 'Reconnecting...'}
//           </span>
//         </div>
//       </div>

//       {/* Tab Navigation */}
//       {showScheduler && (
//         <div className="border-b border-gray-100 mb-4">
//           <div className="flex gap-1">
//             <TabButton
//               active={activeTab === "create"}
//               onClick={() => setActiveTab("create")}
//               icon={Plus}
//             >
//               Create Booking
//             </TabButton>
//             <TabButton
//               active={activeTab === "bookings"}
//               onClick={() => setActiveTab("bookings")}
//               icon={List}
//             >
//               My Bookings
//             </TabButton>
//           </div>
//         </div>
//       )}

//       {/* Availability Graph */}
//       {showAvailability && (
//         <div className="mb-4">
//           {availabilityLoading ? (
//             <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-8 text-center">
//               <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
//               <p className="text-xs text-gray-500">Loading availability...</p>
//             </div>
//           ) : (
//             <BookingGraph
//               bookings={availabilityBookings}
//               vehicles={Array.isArray(vehicles) ? vehicles : []}
//               initialDate={new Date().toISOString().split("T")[0]}
//               onCreateBooking={(bookingData) => {
//                 setShowScheduler(true);
//                 setActiveTab("create");
//                 setShowAvailability(false);
//                 console.log("Create booking with data:", bookingData);
//               }}
//               onEditBooking={(booking) => {
//                 console.log("Edit booking:", booking);
//               }}
//             />
//           )}
//         </div>
//       )}

//       {/* Advanced Booking Form Modal */}
//       {showAdvancedForm && (
//         <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden mb-4">
//           <AdvancedBookingForm
//             vehicles={Array.isArray(vehicles) ? vehicles : []}
//             onBookingCreated={async () => {
//               setShowAdvancedForm(false);
//               await fetchInitialBookingDetails();
//               await loadBookings();
//             }}
//             onClose={() => setShowAdvancedForm(false)}
//           />
//         </div>
//       )}

//       {/* Main Content */}
//       {!showAdvancedForm && (
//         <>
//           {/* Create Booking Tab */}
//           {showScheduler && activeTab === "create" && (
//             <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//               {vehiclesLoading ? (
//                 <div className="p-8 text-center">
//                   <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
//                   <p className="text-xs text-gray-500">Loading vehicles...</p>
//                 </div>
//               ) : vehiclesError ? (
//                 <div className="p-6 text-center">
//                   <div className="bg-red-50 border border-red-100 rounded-lg p-4">
//                     <h3 className="text-sm font-semibold text-red-900 mb-1">Unable to Load Vehicles</h3>
//                     <p className="text-xs text-red-700 mb-3">{vehiclesError}</p>
//                     <button
//                       onClick={() => window.location.reload()}
//                       className="px-3 py-1.5 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition"
//                     >
//                       Try Again
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <BookingScheduler
//                   vehicles={Array.isArray(vehicles) ? vehicles : []}
//                   onBookingCreated={async () => {
//                     setShowScheduler(false);
//                     setActiveTab("bookings");
//                     await fetchInitialBookingDetails();
//                     await loadBookings();
//                   }}
//                 />
//               )}
//             </div>
//           )}

//           {/* My Bookings Tab */}
//           {(showScheduler || activeTab === "bookings") && !showAvailability && (
//             <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
//               {bookingsLoading ? (
//                 <div className="p-8 text-center">
//                   <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
//                   <p className="text-xs text-gray-500">Loading your bookings...</p>
//                 </div>
//               ) : bookings && bookings.length > 0 ? (
//                 <ScheduledBookingList />
//               ) : (
//                 <div className="p-12 text-center">
//                   <div className="flex flex-col items-center gap-3">
//                     <div className="p-3 bg-gray-50 rounded-full">
//                       <Calendar size={32} className="text-gray-400" />
//                     </div>
//                     <div>
//                       <h3 className="text-sm font-semibold text-gray-900 mb-1">No Bookings Yet</h3>
//                       <p className="text-xs text-gray-500 mb-4">Start by creating your first scheduled vehicle booking</p>
//                       <button
//                         onClick={() => {
//                           setShowAdvancedForm(true);
//                         }}
//                         className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition"
//                       >
//                         <Plus size={14} />
//                         Create Your First Booking
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </>
//       )}
//     </EmployeeLayout>
//   );
// }





import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Calendar, Plus, List, Loader, ChevronRight, Clock, MapPin, Truck, XCircle, X, Bell, AlertTriangle } from "lucide-react";
import BookingScheduler from "../components/BookingSchedulerNew";
import BookingRequestList from "../components/Bookingrequestlist";
import ScheduledBookingList from "../components/ScheduledBookingList";
import BookingGraph from "../components/BookingGraph";
import { useVehicles } from "../hooks/useVehicles";
import { useScheduledBookings } from "../hooks/useScheduledBookings";
import EmployeeLayout from "../components/EmployeeLayout";
import AdvancedBookingForm from "../pages/Advancedbookingform";
import {
  getForkBookingDetailsAll,
  getFBookingDetails,
  getForkBookingDetailsByDate,
} from "../services/bookingService";

// ─── Cancellation Notification Popup for Employees ──────────────────────────
function CancelNotificationPopup({ notifications, onDismiss }) {
  if (!notifications || notifications.length === 0) return null;

  return (
    <div className="fixed top-6 right-6 z-[9999] flex flex-col gap-3 max-w-sm w-full">
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(110%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
        .cancel-notif { animation: slideInRight 0.3s ease-out; }
      `}</style>
      {notifications.map((n) => (
        <div
          key={n.id}
          className="cancel-notif bg-white border-l-4 border-red-500 rounded-xl shadow-2xl p-4"
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-start gap-3">
              <div className="p-2 bg-red-100 rounded-lg shrink-0 mt-0.5">
                <XCircle size={18} className="text-red-600" />
              </div>
              <div>
                <p className="text-sm font-bold text-gray-900 mb-1">
                  ⚠️ Your Booking Was Cancelled
                </p>
                <p className="text-xs font-semibold text-red-700 mb-1">
                  Booking #{n.bookingId}
                </p>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {n.reason}
                </p>
                <p className="text-xs text-gray-400 mt-2">{n.time}</p>
              </div>
            </div>
            <button
              onClick={() => onDismiss(n.id)}
              className="p-1 hover:bg-gray-100 rounded-lg transition shrink-0"
            >
              <X size={14} className="text-gray-400" />
            </button>
          </div>
          <button
            onClick={() => onDismiss(n.id)}
            className="mt-3 w-full px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-700 text-xs font-semibold rounded-lg transition"
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}

// ─── WebSocket Connection for Real-time Updates ────────────────────────────
const BOOKING_WS_URL = 'wss://aeroviewbackend.dockyardsoftware.com:8095/Booking';

// Tab Button Component
function TabButton({ active, onClick, children, icon: Icon }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-all border-b-2 ${
        active
          ? "text-gray-900 border-gray-900"
          : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
      }`}
    >
      {Icon && <Icon size={14} />}
      {children}
    </button>
  );
}

// Stat Card Component
function StatCard({ title, value, icon: Icon, color, onClick }) {
  const colorClasses = {
    blue: "bg-blue-50 border-blue-200 text-blue-600",
    green: "bg-emerald-50 border-emerald-200 text-emerald-600",
    purple: "bg-purple-50 border-purple-200 text-purple-600",
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-600",
    red: "bg-red-50 border-red-200 text-red-600",
  };
  
  const bgColor = colorClasses[color] || colorClasses.blue;
  
  return (
    <div
      onClick={onClick}
      className={`${bgColor} border rounded-lg p-3 cursor-pointer transition-all hover:shadow-md`}
    >
      <div className="flex items-center justify-between mb-1">
        <Icon size={14} className={bgColor.split(' ')[2]} />
        <span className="text-lg font-bold">{value}</span>
      </div>
      <p className="text-xs font-medium">{title}</p>
    </div>
  );
}

export default function ScheduleBooking() {
  const navigate = useNavigate();
  const { authKey, userDetails } = useSelector((state) => state.auth);
  const {
    vehicles,
    loading: vehiclesLoading,
    error: vehiclesError,
    loadVehicles,
  } = useVehicles();
  const {
    bookings,
    loading: bookingsLoading,
    loadBookings,
  } = useScheduledBookings();
  const [showScheduler, setShowScheduler] = useState(false);
  const [activeTab, setActiveTab] = useState("bookings");
  const [showAvailability, setShowAvailability] = useState(false);
  const [availabilityBookings, setAvailabilityBookings] = useState([]);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [showAdvancedForm, setShowAdvancedForm] = useState(false);
  
  // ─── Refresh key for BookingRequestList ────────────────────────────────────
  const [refreshKey, setRefreshKey] = useState(0);
  
  // ─── Cancellation Notifications State ────────────────────────────────────
  const [cancelNotifications, setCancelNotifications] = useState([]);
  
  // ─── WebSocket Ref ───────────────────────────────────────────────────────
  const wsRef = useRef(null);
  const lastWsFetchRef = useRef(0);
  const wsFetchTimerRef = useRef(null);

  useEffect(() => {
    if (!authKey) {
      navigate("/login");
    }
  }, [authKey, navigate]);

  const fetchInitialBookingDetails = async () => {
    console.log("[ScheduleBooking] Fetching initial booking details...");
    try {
      const [forkDetails, bookingDetails] = await Promise.all([
        getForkBookingDetailsAll(),
        getFBookingDetails(),
      ]);
      console.log("[ScheduleBooking] Fork booking details fetched:", forkDetails);
      console.log("[ScheduleBooking] Booking details fetched:", bookingDetails);
    } catch (error) {
      console.error("[ScheduleBooking] Error fetching initial booking details:", error);
    }
  };

  // ─── Refresh All Bookings ────────────────────────────────────────────────
  const refreshAllBookings = async () => {
    await Promise.all([
      loadBookings(),
      fetchInitialBookingDetails(),
    ]);
  };

  // ─── Trigger BookingRequestList Refresh ──────────────────────────────────
  const triggerBookingRequestsRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
    console.log("[ScheduleBooking] Triggered BookingRequestList refresh");
  }, []);

  // ─── Show Cancellation Notification (from WebSocket/Admin) ───────────────
  const showCancelNotification = useCallback((bookingId, reason) => {
    const n = {
      id:        `${bookingId}-${Date.now()}`,
      bookingId,
      reason,
      time:      new Date().toLocaleTimeString(),
    };
    setCancelNotifications(prev => [...prev, n]);
    
    // Auto-dismiss after 30 seconds
    setTimeout(() => {
      setCancelNotifications(prev => prev.filter(x => x.id !== n.id));
    }, 30000);
  }, []);

  const dismissCancelNotification = useCallback((notifId) => {
    setCancelNotifications(prev => prev.filter(n => n.id !== notifId));
  }, []);

  // ─── WebSocket Connection for Real-time Cancellations ────────────────────
  useEffect(() => {
    if (!authKey) return;
    
    // Close existing connection
    if (wsRef.current) {
      wsRef.current.close();
    }
    
    console.log("[ScheduleBooking] Connecting to WebSocket...");
    wsRef.current = new WebSocket(`${BOOKING_WS_URL}?token=${encodeURIComponent(authKey)}`);
    
    wsRef.current.onopen = () => {
      console.log("[ScheduleBooking] ✅ Booking WebSocket Connected");
    };
    
    wsRef.current.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        console.log("[ScheduleBooking] WebSocket message received:", message);
        
        // Handle cancellation messages from Admin
        if (message.type === 'BOOKING_CANCELLED' || 
            message.action === 'cancel' ||
            message.cancelled === true ||
            (message.status === 'Cancel' && message.previousStatus === 'Pending')) {
          
          const bookingId = message.bId || message.bookingId || message.reqId;
          const cancelReason = message.reason || 
            message.cancelReason || 
            "Your booking was cancelled by the administrator as no suitable vehicle was available.";
          
          if (bookingId) {
            console.log(`[ScheduleBooking] 📢 Booking ${bookingId} was cancelled by supervisor`);
            showCancelNotification(bookingId, cancelReason);
            
            // Refresh bookings to show updated status
            refreshAllBookings();
            triggerBookingRequestsRefresh();
          }
        }
        
        // Handle any booking update (including cancellations)
        if (message.type || message.action || message.bId || message.bookingId) {
          const now = Date.now();
          const minGap = 3000; // 3 second throttle
          
          if (now - lastWsFetchRef.current >= minGap) {
            lastWsFetchRef.current = now;
            refreshAllBookings();
            triggerBookingRequestsRefresh();
          } else if (!wsFetchTimerRef.current) {
            const delay = minGap - (now - lastWsFetchRef.current);
            wsFetchTimerRef.current = setTimeout(() => {
              lastWsFetchRef.current = Date.now();
              wsFetchTimerRef.current = null;
              refreshAllBookings();
              triggerBookingRequestsRefresh();
            }, delay);
          }
        }
      } catch (error) {
        console.error("[ScheduleBooking] Error parsing WebSocket message:", error);
      }
    };
    
    wsRef.current.onerror = (error) => {
      console.error("[ScheduleBooking] WebSocket Error:", error);
    };
    
    wsRef.current.onclose = () => {
      console.log("[ScheduleBooking] WebSocket Disconnected");
    };
    
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
      if (wsFetchTimerRef.current) {
        clearTimeout(wsFetchTimerRef.current);
        wsFetchTimerRef.current = null;
      }
    };
  }, [authKey, showCancelNotification, triggerBookingRequestsRefresh]);

  useEffect(() => {
    if (authKey) {
      loadVehicles();
      loadBookings();
      fetchInitialBookingDetails();
    }
  }, [authKey, loadVehicles, loadBookings]);

  // Calculate booking stats - including cancelled count
  const bookingStats = {
    total: bookings?.length || 0,
    pending: bookings?.filter(b => b.status === "Pending" || b.status === "P").length || 0,
    active: bookings?.filter(b => b.status === "Active" || b.status === "A").length || 0,
    completed: bookings?.filter(b => b.status === "Completed" || b.status === "CO").length || 0,
    cancelled: bookings?.filter(b => b.status === "Cancel" || b.status === "C").length || 0,
  };

  if (!userDetails) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-8 text-center max-w-md">
          <Loader className="mx-auto mb-4 text-gray-400 animate-spin" size={32} />
          <h2 className="text-lg font-semibold text-gray-900 mb-1">Loading Your Session</h2>
          <p className="text-xs text-gray-500">Please wait...</p>
        </div>
      </div>
    );
  }

  return (
    <EmployeeLayout>
      {/* ─── Cancellation Notification Popups ────────────────────────────── */}
      <CancelNotificationPopup
        notifications={cancelNotifications}
        onDismiss={dismissCancelNotification}
      />

      {/* Header Section */}
      <div className="mb-4">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <div>
            <h1 className="text-lg sm:text-xl font-semibold text-gray-900 flex items-center gap-2">
              <Calendar size={20} />
              Booking
            </h1>
            <p className="text-xs text-gray-500 mt-0.5">
              Book vehicles with precision timing
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {/* {!showScheduler && !showAdvancedForm && (
              <button
                onClick={async () => {
                  const isOpening = !showAvailability;
                  if (isOpening) {
                    setAvailabilityLoading(true);
                    try {
                      const today = new Date();
                      const startOfWeek = new Date(today);
                      startOfWeek.setDate(today.getDate() - today.getDay() + 1);
                      const weekDates = [];
                      for (let i = 0; i < 7; i++) {
                        const date = new Date(startOfWeek);
                        date.setDate(startOfWeek.getDate() + i);
                        weekDates.push(date.toISOString().split("T")[0]);
                      }
                      const bookingsArrays = await Promise.all(
                        weekDates.map((date) => getForkBookingDetailsByDate(date))
                      );
                      const allBookings = bookingsArrays.flat();
                      setAvailabilityBookings(Array.isArray(allBookings) ? allBookings : []);
                    } catch (error) {
                      console.error("Error fetching fork bookings:", error);
                      setAvailabilityBookings([]);
                    } finally {
                      setAvailabilityLoading(false);
                    }
                  }
                  setShowAvailability(isOpening);
                  if (isOpening) setShowScheduler(false);
                }}
                disabled={availabilityLoading}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition ${
                  showAvailability
                    ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    : "bg-gray-900 text-white hover:bg-gray-800"
                } disabled:opacity-50`}
              >
                <Calendar size={14} />
                {availabilityLoading ? "Loading..." : showAvailability ? "Hide Availability" : "Check Availability"}
              </button>
            )} */}
            
            {!showScheduler && !showAdvancedForm && (
              <button
                onClick={() => {
                  setShowAdvancedForm(true);
                  setShowAvailability(false);
                }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition"
              >
                <Plus size={14} />
                Unplanned Booking
              </button>
            )}

            {(!showScheduler || activeTab === "bookings") && !showAdvancedForm && (
              <button
                onClick={() => {
                  setShowScheduler(true);
                  setActiveTab("create");
                  setShowAvailability(false);
                }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 transition"
              >
                <Plus size={14} />
                Schedule Booking
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4">
        <StatCard title="Total Bookings" value={bookingStats.total} icon={Calendar} color="blue" />
        <StatCard title="Active" value={bookingStats.active} icon={Clock} color="green" />
        <StatCard title="Pending" value={bookingStats.pending} icon={Loader} color="yellow" />
        <StatCard title="Completed" value={bookingStats.completed} icon={Truck} color="purple" />
        <StatCard title="Cancelled" value={bookingStats.cancelled} icon={XCircle} color="red" />
      </div>

      {/* WebSocket Status Indicator */}
      <div className="flex items-center justify-end mb-3">
        <div className="flex items-center gap-2 px-2 py-1 bg-gray-50 rounded-full">
          <div className={`w-2 h-2 rounded-full ${wsRef.current?.readyState === WebSocket.OPEN ? 'bg-green-500 animate-pulse' : 'bg-red-500'}`}></div>
          <span className="text-xs text-gray-500">
            {wsRef.current?.readyState === WebSocket.OPEN ? 'Live Updates Active' : 'Reconnecting...'}
          </span>
        </div>
      </div>

      {/* Tab Navigation */}
      {showScheduler && (
        <div className="border-b border-gray-100 mb-4">
          <div className="flex gap-1">
            <TabButton
              active={activeTab === "create"}
              onClick={() => setActiveTab("create")}
              icon={Plus}
            >
              Create Booking
            </TabButton>
            <TabButton
              active={activeTab === "bookings"}
              onClick={() => setActiveTab("bookings")}
              icon={List}
            >
              My Bookings
            </TabButton>
          </div>
        </div>
      )}

      {/* Availability Graph */}
      {showAvailability && (
        <div className="mb-4">
          {availabilityLoading ? (
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-8 text-center">
              <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
              <p className="text-xs text-gray-500">Loading availability...</p>
            </div>
          ) : (
            <BookingGraph
              bookings={availabilityBookings}
              vehicles={Array.isArray(vehicles) ? vehicles : []}
              initialDate={new Date().toISOString().split("T")[0]}
              onCreateBooking={(bookingData) => {
                setShowScheduler(true);
                setActiveTab("create");
                setShowAvailability(false);
                console.log("Create booking with data:", bookingData);
              }}
              onEditBooking={(booking) => {
                console.log("Edit booking:", booking);
              }}
            />
          )}
        </div>
      )}

      {/* Advanced Booking Form Modal */}
      {showAdvancedForm && (
        <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden mb-4">
          <AdvancedBookingForm
            vehicles={Array.isArray(vehicles) ? vehicles : []}
            onBookingCreated={async () => {
              setShowAdvancedForm(false);
              await fetchInitialBookingDetails();
              await loadBookings();
              triggerBookingRequestsRefresh(); // Refresh booking requests
            }}
            onClose={() => setShowAdvancedForm(false)}
          />
        </div>
      )}

      {/* Main Content */}
      {!showAdvancedForm && (
        <>
          {/* Create Booking Tab */}
          {showScheduler && activeTab === "create" && (
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
              {vehiclesLoading ? (
                <div className="p-8 text-center">
                  <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
                  <p className="text-xs text-gray-500">Loading vehicles...</p>
                </div>
              ) : vehiclesError ? (
                <div className="p-6 text-center">
                  <div className="bg-red-50 border border-red-100 rounded-lg p-4">
                    <h3 className="text-sm font-semibold text-red-900 mb-1">Unable to Load Vehicles</h3>
                    <p className="text-xs text-red-700 mb-3">{vehiclesError}</p>
                    <button
                      onClick={() => window.location.reload()}
                      className="px-3 py-1.5 bg-red-600 text-white text-xs rounded-lg hover:bg-red-700 transition"
                    >
                      Try Again
                    </button>
                  </div>
                </div>
              ) : (
                <BookingScheduler
                  vehicles={Array.isArray(vehicles) ? vehicles : []}
                  onBookingCreated={async (newBooking) => {
                    setShowScheduler(false);
                    setActiveTab("bookings");
                    await fetchInitialBookingDetails();
                    await loadBookings();
                    triggerBookingRequestsRefresh(); // 🔴 Refresh booking requests
                    console.log("Booking created, refreshing requests list", newBooking);
                  }}
                />
              )}
            </div>
          )}

          {/* My Bookings Tab - Now includes BookingRequestList always */}
          {(showScheduler || activeTab === "bookings") && !showAvailability && (
            <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden">
              {bookingsLoading ? (
                <div className="p-8 text-center">
                  <Loader className="mx-auto mb-3 text-gray-400 animate-spin" size={24} />
                  <p className="text-xs text-gray-500">Loading your bookings...</p>
                </div>
              ) : (
                <>
                  <ScheduledBookingList />
                  {/* BookingRequestList with refresh key - Always visible */}
                  <div className="border-t border-gray-200 mt-4 pt-4">
                    <BookingRequestList key={refreshKey} />
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}
    </EmployeeLayout>
  );
}